<div class="footer-block" >
    <p>© {{footerYear}} Beto Paredes, LLC. All rights reserved.</p>
</div>
